import { createBrowserRouter } from 'react-router-dom';

import { LoginPage } from '@/features/auth';
import { BeerHomePage, WineHomePage } from '@/features/dashboard';
import {
  FermentationPage,
  FermentationTourPage,
  TrackingOverviewPage,
} from '@/features/fermentation';
import {
  BBPitchRateCalculator,
  FWPitchRateCalculator,
} from '@/features/pitch-rate-calculator';
import { AnalysisHistoryPage, AnalysisPage } from '@/features/single-measurement';
import { ProtectedLayout, UnprotectedLayout } from '@/layouts';
import { NotFoundErrorPage } from '@/pages';
import { DebugPage } from '@/pages/debug';

import { RedirectToHome } from './redirect-home';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <UnprotectedLayout />,
    errorElement: <NotFoundErrorPage />,
    children: [
      {
        index: true,
        element: <LoginPage />,
      },
      {
        path: 'password-reset/:resetToken',
        element: <LoginPage />,
      },
    ],
  },
  {
    path: '/dashboard',
    element: <ProtectedLayout />,
    errorElement: <NotFoundErrorPage />,
    children: [
      {
        index: true,
        element: <RedirectToHome />,
      },
      {
        path: 'wine',
        children: [
          {
            index: true,
            element: <WineHomePage />,
          },
          {
            path: 'measurements',
            children: [
              {
                index: true,
                element: <AnalysisHistoryPage />,
              },
              {
                path: ':batchId',
                element: <AnalysisPage />,
              },
              {
                path: ':batchId/pitch-calculator',
                element: <FWPitchRateCalculator />,
              },
            ],
          },
          {
            path: 'fermentations',
            children: [
              {
                index: true,
                element: <TrackingOverviewPage />,
              },
              {
                path: ':fermentationId',
                element: <FermentationPage />,
              },
              {
                path: ':fermentationId/batch/:batchId',
                element: <FermentationPage />,
              },
              {
                path: 'tour',
                element: <FermentationTourPage />,
              },
              {
                path: 'tour/batch/:batchId',
                element: <FermentationTourPage />,
              },
            ],
          },
        ],
      },
      {
        path: 'beer',
        children: [
          {
            index: true,
            element: <BeerHomePage />,
          },
          {
            path: 'measurements',
            children: [
              {
                index: true,
                element: <AnalysisHistoryPage />,
              },
              {
                path: ':batchId',
                element: <AnalysisPage />,
              },
              {
                path: ':batchId/pitch-calculator',
                element: <BBPitchRateCalculator />,
              },
            ],
          },
          {
            path: 'fermentations',
            children: [
              {
                index: true,
                element: <TrackingOverviewPage />,
              },
              {
                path: ':fermentationId',
                element: <FermentationPage />,
              },
              {
                path: ':fermentationId/batch/:batchId',
                element: <FermentationPage />,
              },
              {
                path: 'tour',
                element: <FermentationTourPage />,
              },
              {
                path: 'tour/batch/:batchId',
                element: <FermentationTourPage />,
              },
            ],
          },
        ],
      },
      {
        path: 'ethanol',
        children: [
          {
            index: true,
            element: <WineHomePage />,
          },
          {
            path: 'measurements',
            children: [
              {
                index: true,
                element: <AnalysisHistoryPage />,
              },
              {
                path: ':batchId',
                element: <AnalysisPage />,
              },
              {
                path: ':batchId/pitch-calculator',
                element: <FWPitchRateCalculator />,
              },
            ],
          },
          {
            path: 'fermentations',
            children: [
              {
                index: true,
                element: <TrackingOverviewPage />,
              },
              {
                path: ':fermentationId',
                element: <FermentationPage />,
              },
              {
                path: ':fermentationId/batch/:batchId',
                element: <FermentationPage />,
              },
              {
                path: 'tour',
                element: <FermentationTourPage />,
              },
              {
                path: 'tour/batch/:batchId',
                element: <FermentationTourPage />,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '/debug',
    element: <DebugPage />,
  },
]);
